import { Box, Text } from '@quintoandar-tokko/jopijs';
import TrendChip from '../../TrendChip';
import styles from './performanceCard.module.scss';

export default function PerformanceCardSummary({
  value,
  tendency,
  percentageStatus,
  icon,
  children,
  className = '',
  ...rest
}) {
  return (
    <Box className={`${styles.summary} ${className}`} {...rest}>
      <Box className={styles.summaryTextWrapper}>
        <Text className={styles.summaryText} title={value}>
          {value}
        </Text>
        <TrendChip
          text={tendency}
          icon={icon}
          percentageStatus={percentageStatus}
        />
      </Box>

      {children}
    </Box>
  );
}
